import { UniversalArrayHelper } from '@biteinc/helpers-universal';
export function swap(array, i, j) {
    if (!array || i < 0 || i >= array.length || j < 0 || j >= array.length) {
        return;
    }
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
}
export function move(array, oldIndex, newIndex) {
    const element = array.splice(oldIndex, 1)[0];
    array.splice(newIndex, 0, element);
}
export function removeWhere(array, testFunction) {
    for (let i = array.length - 1; i >= 0; i--) {
        const element = array[i];
        if (testFunction(element)) {
            array.splice(i, 1);
        }
    }
}
export function remove(array, element) {
    removeWhere(array, (el) => {
        return el === element;
    });
}
export const set = UniversalArrayHelper.set;
export const keyMap = UniversalArrayHelper.keyMap;
export const addToIdSet = UniversalArrayHelper.addToIdSet;
export function min(array, predicate) {
    let minimum;
    for (const element of array) {
        const value = predicate(element);
        if (!minimum || value < minimum.value) {
            minimum = { element, value };
        }
    }
    if (!minimum) {
        throw new Error('cannot find min element in an empty array');
    }
    return minimum.element;
}
export function sortAscending(array, predicate) {
    if (!predicate) {
        array.sort();
        return array;
    }
    array.sort((a, b) => {
        const aVal = predicate(a);
        const bVal = predicate(b);
        if (aVal < bVal) {
            return -1;
        }
        if (aVal > bVal) {
            return 1;
        }
        return 0;
    });
    return array;
}
export function sortDescending(array, predicate) {
    if (!predicate) {
        array.sort().reverse();
        return array;
    }
    array.sort((a, b) => {
        const aVal = predicate(a);
        const bVal = predicate(b);
        if (aVal < bVal) {
            return 1;
        }
        if (aVal > bVal) {
            return -1;
        }
        return 0;
    });
    return array;
}
export const isUnique = UniversalArrayHelper.isUnique;
export function mergeSorted(tArray, sArray, compareFn) {
    const merged = [];
    let i = 0;
    let j = 0;
    while (i < tArray.length && j < sArray.length) {
        if (compareFn(tArray[i], sArray[j]) <= 0) {
            merged.push(tArray[i]);
            ++i;
        }
        else {
            merged.push(sArray[j]);
            ++j;
        }
    }
    while (i < tArray.length) {
        merged.push(tArray[i]);
        ++i;
    }
    while (j < sArray.length) {
        merged.push(sArray[j]);
        ++j;
    }
    return merged;
}
export function isSorted(array, compareFn) {
    for (let i = 1; i < array.length; ++i) {
        if (compareFn(array[i - 1], array[i]) > 0) {
            return false;
        }
    }
    return true;
}
export function split(inputArray, chunkSize) {
    const result = [];
    for (let i = 0; i < inputArray.length; i += chunkSize) {
        result.push(inputArray.slice(i, i + chunkSize));
    }
    return result;
}
//# sourceMappingURL=array_helper.js.map